<script>
import options from './StreamDonationOverviewNewDonation.options'
export default options
</script>

<template>
  <div class="kb-stream-donation-overview-new-donation"
    :class="[
      { 'kb-stream-donation-overview-new-donation--previous': previous },
      `kb-stream-donation-overview-new-donation--style-${donationStyle}`
    ]">
    <div class="kb-stream-donation-overview-new-donation__icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M16.5 2.5C18.0913 2.5 19.617 3.13259 20.7422 4.25781C21.8674 5.38303 22.5 6.9087 22.5 8.5C22.5 11.015 20.8405 12.8941 19.3525 14.3525L19.3535 14.3535L12.3535 21.3535C12.1583 21.5488 11.8417 21.5488 11.6465 21.3535L4.65234 14.3594C3.14954 12.9066 1.5 11.0265 1.5 8.5L1.50781 8.20215C1.58146 6.7193 2.203 5.31262 3.25781 4.25781C4.38303 3.13259 5.9087 2.5 7.5 2.5C8.43006 2.5 9.25134 2.63302 10.0469 2.97949C10.7186 3.27204 11.3492 3.70756 12 4.30762C12.6508 3.70756 13.2814 3.27204 13.9531 2.97949C14.7487 2.63302 15.5699 2.5 16.5 2.5Z"
          fill="white" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    <span class="kb-stream-donation-overview-new-donation__amount">{{ amount }} kr</span>
    <span class="kb-stream-donation-overview-new-donation__from">fra {{ donorName }}</span>
  </div>
</template>
